import { create } from 'zustand';

export const useNotificationStore = create((set) => ({
  open: false,
  content: null,
  variant: 'success',

  setNotification: (content, variant = 'success') =>
    set({
      open: true,
      content,
      variant,
    }),

  closeNotification: () =>
    set({
      open: false,
    }),
}));
